import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-ink-900 px-4 py-10 sm:px-6 sm:py-14" data-id="element-67" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-xl rounded-xl border border-gold-500/40 bg-ink-800 px-5 py-7 text-center" data-id="element-68" data-mp="4w1furkch2ib">
        <span aria-hidden="true" className="text-3xl" data-id="element-69" data-mp="9srxhjbss65u">
          🛡️
        </span>
        <h2 className="mt-3 text-lg font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-70" data-mp="eu8v95yzjci7">
          Garantía 7 días — sin preguntas
        </h2>
        <p className="mt-2 text-sm text-neutral-300 sm:text-base" data-id="element-71" data-mp="nu4ablvnvrni">
          Devolución del{' '}
          <span className="font-extrabold text-gold-500" data-id="element-72" data-mp="skudqtkj1kfk">100%</span> sin
          formularios.
        </p>
      </div>
    </section>;
}